var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.125 10.031c-.896 0-1.594.73-1.594 1.594 0 .896.698 1.594 1.594 1.594v2.656A2.12 2.12 0 0 1 17 18H2.125A2.1 2.1 0 0 1 0 15.875v-2.656c.863 0 1.594-.697 1.594-1.594 0-.863-.73-1.594-1.594-1.594V7.375C0 6.213.93 5.25 2.125 5.25H17a2.14 2.14 0 0 1 2.125 2.125zm-17-3.719a1.07 1.07 0 0 0-1.062 1.063v1.826a2.67 2.67 0 0 1 1.593 2.424c0 1.096-.664 2.025-1.594 2.457v1.793c0 .598.465 1.063 1.063 1.063H17a1.07 1.07 0 0 0 1.063-1.063v-1.793a2.66 2.66 0 0 1-1.594-2.457c0-1.062.63-2.025 1.593-2.424V7.375c0-.564-.498-1.062-1.062-1.062z"
  })));
};
export default SvgTicket;